export const ItemTableHeaders=[
    {
        Header:'Style',
        accessor:'style'
    },
    
    {
        Header:'Company',
        accessor:'company'
    },
    {
        Header:'Color',
        accessor:'color'
    },
    {
        Header:'US Size',
        accessor:'USSize'
    },
    {
        Header:'EUR Size',
        accessor:'EURSize'
    },
    {
        Header:'Quantity',
        accessor:'quantity'
    },
    {
        Header:'Cost',
        accessor:'cost'
    },
    {
        Header:'Price',
        accessor:'price'
    },
    {
        Header:'Type',
        accessor:'type'
    },
    {
        Header:'',
        accessor:'select'
    }
]

export const ItemPrintTableHeaders=[
    {
        Header:'Style',
        accessor:'style'
    },
    
    {
        Header:'Company',
        accessor:'company'
    },
    {
        Header:'Color',
        accessor:'color'
    },
    {
        Header:'US Size',
        accessor:'USSize'
    },
    {
        Header:'EUR Size',
        accessor:'EURSize'
    },
    {
        Header:'Quantity',
        accessor:'quantity'
    },
    {
        Header:'Price',
        accessor:'price'
    },
]

export const ItemMobileTableHeaders=[
    {
        Header:'Style',
        accessor:'style'
    },
    
    {
        Header:'Company',
        accessor:'company'
    },
    {
        Header:'Color',
        accessor:'color'
    },
    {
        Header:'US Size',
        accessor:'USSize'
    },
    {
        Header:'Price',
        accessor:'price'
    },
    {
        Header:'Type',
        accessor:'type'
    },
    {
        Header:'',
        accessor:'select'
    }
]